let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("doXbd")).then(() => parcelRequire('2AHjI'));